<template>
  <div v-if="asset" :class="['VvHero', inverted ? 'inverted' : '']" :style="containerStyle">
    <span :class="['Title', ['mobile', 'tablet'].includes($mq) ? 'TitleMobile' : '']">{{ title }}</span>
    <vv-button v-if="scrollTo" @click="$emit('scrollView', scrollTo)" :class="'primary-variant'" :style="{ 'bottom': height == 200 ? '-75px' : '-180px' }">
      {{ $t('masterclass-content-tile.begin') }}
    </vv-button>
  </div>
</template>

<script>
import VvButton from '@/components/common/VvButton.vue'

export default {
  name: 'VvHero',
  components: {
    VvButton
  },
  props: {
    height: {
      type: [String, Number],
      default: '200'
    },
    backgroundPositionY: {
      type: [String, Number],
      default: '0'
    },
    title: {
      type: String,
      required: true
    },
    asset: {
      type: String,
      required: true
    },
    scrollTo: {
      type: String,
      required: false
    },
    inverted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    containerStyle() {
      const source = this.asset.startsWith('//') ? this.asset : require(`@/assets/${this.asset}`)

      return {
        'background-image': 'url(' + source + ')',
        height: `${this.height}px`,
        'background-position-y': `${this.backgroundPositionY}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.VvHero {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  .Title {
    position: relative;
    font-family: Helvetica, sans-serif;
    font-weight: bold;
    font-size: 35px;
    color: $font-button;
    z-index: 2;

    &.TitleMobile {
      font-size: 25px;
      text-align: center;

      &::before {
        content: '';
        z-index: -1;
        position: absolute;
        display: block;
        height: 8px;
        background-color: $primary;
        bottom: 2.5px;
        left: 5%;
        width: 90%;
      }
    }

    &::before {
      content: '';
      z-index: -1;
      position: absolute;
      display: block;
      height: 15px;
      background-color: $primary;
      bottom: 2.5px;
      left: -5%;
      width: 110%;
    }
  }

  &.inverted {
    .Title {
      color: $font-banner;

      &::before {
        background-color: $primary-alt;
      }
    }
  }

  .vv-button {
    position: relative;
  }
}
</style>
